###

When attached to a DOM element, this directive will destory any visible
tooltips when the $rootScope broadcasts a 'hide-tooltips' event.

###

angular.module('rjmNg.directives').directive "hideTooltip", [
  "$window"
  "$rootScope"
  ($window, $rootScope) ->
    restrict: "A"
    (scope, element, attrs) ->

      $rootScope.$on "hide-tooltips", () ->
        element.find('.tooltip').remove()

]
